var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code-stepup',{staticClass:"isotope-step-up-category--sms-code",attrs:{"stepUpCategory":_vm.stepUpCategory}})}
var staticRenderFns = []

export { render, staticRenderFns }